var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-menu", class: _vm.rootClasses }, [
    _c("div", { staticClass: "main-menu--background" }),
    _vm._v(" "),
    _c("div", { staticClass: "main-menu--list" }, [
      _c("div", { staticClass: "main-menu--items" }, [
        _c(
          "div",
          { staticClass: "main-menu--item main-menu--item__home-link" },
          [
            _c(
              "conditional-link",
              {
                staticClass: "u-reset main-menu--home-link",
                attrs: { to: { name: _vm.home } }
              },
              [
                _c("ui-icon", {
                  staticClass: "main-menu--home-image",
                  attrs: { symbol: "gk-logo" }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "main-menu--mobile-switcher" },
      [
        _c(
          "transition",
          { attrs: { name: "trs-simple-fade" } },
          [_vm.showMobileSwitcher ? _c("mobile-switcher") : _vm._e()],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "main-menu--hamburger", style: _vm.hamburgerStyles },
      [_c("hamburger-btn")],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c8d6784", { render: render, staticRenderFns: staticRenderFns })
  }
}